import { LegendOption } from './LegendBlock.component';
import React, { ComponentPropsWithRef, FC } from 'react';
import { Text } from '@components/Text/Text.component';
import classnames from 'classnames';

export const LegendItem: FC<LegendOption & ComponentPropsWithRef<'div'>> = ({
  labelI18n,
  label,
  icon,
  className,
  ...rest
}) => {
  const rootClassName = classnames('flex', 'align-center', className);
  return (
    <div className={rootClassName} key={labelI18n} {...rest}>
      <div className="plc-mr-s flex align-center justify-center">{icon}</div>
      <Text i18nKey={labelI18n} tag="span" variant="small">
        {label}
      </Text>
    </div>
  );
};
